const responseValues = (value) => {
  if (Array.isArray(value)) return value;
  if (value === null || value === undefined || value === "") return [];
  return [value];
};

export const collectGroupedProductSelections = (
  questions = [],
  responses = {},
  fallback = [],
) => {
  const selected = [];
  let foundResponse = false;

  questions.forEach((question) => {
    const responseKey = [
      question?.id,
      question?.source_id,
      question?.release_node_id,
    ].find((key) => (
      key && Object.prototype.hasOwnProperty.call(responses, key)
    ));
    if (!responseKey) return;
    foundResponse = true;
    selected.push(...responseValues(responses[responseKey]));
  });

  return foundResponse ? selected : responseValues(fallback);
};
